<template>
    <div>
         <v-row>
            <v-col md="5" cols="12">
                <v-card
                    outlined
                >
                <v-card-title>{{ $t('Product') }}</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col md="12">
                            <p>{{ $t('Functions') }}</p>
                            {{ project.product.functions || '---' }}
                        </v-col>
                    </v-row>
                    <v-divider class="my-3"/>
                    <v-row>
                        <v-col md="12">
                            <p>{{ $t('Usage') }}</p>
                            {{ project.product.usage || '---' }}
                        </v-col>
                    </v-row>
                    <v-divider class="my-3"/>
                    <v-row>
                        <v-col md="12">
                            <p>{{ $t('Packages') }}</p>
                            {{ project.product.packages || '---' }}
                        </v-col>
                    </v-row>
                    <v-divider class="my-3"/>
                    <v-row>
                        <v-col md="12">
                            <p>{{ $t('Services') }}</p>
                            {{ project.product.services || '---' }}
                        </v-col>
                    </v-row>
                </v-card-text>
                </v-card>
            </v-col>
            <v-col md="5" offset-md="2"  cols="12">
                <v-card
                outlined
                >
                    <v-card-title>{{ $t('Price') }}</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col md="12">
                                <p>{{ $t('Our price') }}</p>
                                <div v-currency:VND="project.price.price"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="12">
                                <p>{{ $t('Competitor price') }}</p>
                                <div v-currency:VND="project.price.competitor_price"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="12">
                                <p>{{ $t('Note') }}</p>
                                {{ project.price.note || '---' }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="5" cols="12">
                <v-card
                outlined
                >
                <v-card-title>{{ $t('Places') }}</v-card-title>
                <v-card-text>
                    <div v-if="project.places.length">
                        <div v-for="(place, index) in project.places" :key="`place-${index}`">
                            <v-row>
                                <v-col md="12">{{ place.selling_chanel }}</v-col>
                            </v-row>
                            <v-divider class="my-3"/>
                        </div>
                    </div>
                    <div v-else>{{ $t('No data') }}</div>
                </v-card-text>
                </v-card>
            </v-col>

            <v-col md="5" offset-md="2" cols="12">
                <v-card
                outlined
                >
                <v-card-title>{{ $t('Promotions') }}</v-card-title>
                <v-card-text>
                    <div v-if="project.promotions.length">
                         <div v-for="(promotion, index) in project.promotions" :key="`promotion-${index}`">
                            <v-row>
                                <v-col md="12">{{ promotion.name }}</v-col>
                            </v-row>
                            <v-divider class="my-3"/>
                        </div>
                    </div>
                    <div v-else>{{ $t('No data') }}</div>
                </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
  name: 'ShowBasicInfo',
  props: [
    'project'
  ]
}
</script>
